<div class="mat-elevation-z1">
  <mat-form-field class="w-full lg:w-2/4" [hidden]="!showFilter">
    <input matInput
      (keyup)="applyFilter($event)"
      placeholder="Ex. term +required -exclude"
      [attr.test-id]="'datatable-filter'">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChange.emit($event)">

    @if (showSelect) {
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
            [checked]="isAllSelected()"
            [indeterminate]="selection.selected.length > 0 && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="$event ? toggleRow(row) : null"
            [checked]="isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>
    }

    @for (column of displayedColumns; track column) {
      <ng-container [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>
          @if (column !== 'actions') {
            <div mat-sort-header>
              {{ headers[column] || column }}
            </div>
          }
        </th>
        <td mat-cell *matCellDef="let element">
          @if (column !== 'actions') {
            @if (cellTemplates && cellTemplates[column]) {
              <ng-template [ngTemplateOutlet]="cellTemplates[column]"
                [ngTemplateOutletContext]="{ $implicit: element[column], row: element, column: column }">
              </ng-template>
            } @else {
              {{ element[column] }}
            }
          }
          @if (column === 'actions') {
            <ng-template [ngTemplateOutlet]="cellTemplates[column]"
              [ngTemplateOutletContext]="{ row: element }"></ng-template>
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="finalDisplayedColumns; sticky: true" class="displayHeader"></tr>
    <tr mat-row *matRowDef="let row; columns: finalDisplayedColumns;" class="displayRow"></tr>

  </table>

  <mat-paginator [hidden]="!showPaginator" [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator>
</div>
